import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Bancos } from '../classes/Bancos';

@Injectable({
  providedIn: 'root'
})
export class BancosService {

  constructor(private http: HttpClient) { }

  route = "Bancos";

  Listar(): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}`)
  }

  ObterPorId(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/${this.route}/${id}`)
  }

  Inserir(obj: Bancos): Observable<any>{
    return this.http.post(`${environment.apiURL}/${this.route}`, obj);
  }

  Atualizar(id: number, obj: Bancos): Observable<any>{
    return this.http.put(`${environment.apiURL}/${this.route}/${id}`, obj);
  }

  Excluir(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/${this.route}/${id}`);
  }

}
